import { FC } from "react";

import ComingSoonPage from "./ComingSoonPage";

const SettingsPage: FC = () => (
  <ComingSoonPage
    title="Settings"
    description="Configure feedback collections and notifications. Coming soon."
  />
);

export default SettingsPage;
